import { Text } from "@/components/atoms/Text";

type StatItemProps = {
  value: string | React.ReactNode;
  label: string;
};

const StatItem = ({ value, label }: StatItemProps) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-text-center">
    <Text
      element="p"
      typeface="headline-5-m"
      className="lg:tw-display-1-b tw-text-brand-white"
    >
      {value as string}
    </Text>
    <Text
      element="p"
      typeface="body-2-m"
      className="lg:tw-headline-3-m tw-text-brand-white"
    >
      {label}
    </Text>
  </div>
);

export { StatItem };
